export default function Container(theme) {
  // const paddingXs = 2;
  const paddingSm = 2.5;
  const paddingMd = 3;
  const paddingLg = 4;

  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 8, // TODO : after MCard deployment, replace by theme.spacing(0, paddingXs, paddingXs, paddingXs),
          [theme.breakpoints.up('sm')]: { padding: theme.spacing(0, paddingSm, paddingSm, paddingSm) },
          [theme.breakpoints.up('md')]: { padding: theme.spacing(0, paddingMd, paddingMd, paddingMd) },
          [theme.breakpoints.up('lg')]: { padding: theme.spacing(0, paddingLg, paddingLg, paddingLg) }
        }
      }
    }
  };
}
